export const FETCH_LEGENDCATEGORIES_REQUEST = 'FETCH_LEGENDCATEGORIES_REQUEST';
export const FETCH_LEGENDCATEGORIES_SUCCESS = 'FETCH_LEGENDCATEGORIES_SUCCESS';
export const FETCH_LEGENDCATEGORIES_FAILURE = 'FETCH_LEGENDCATEGORIES_FAILURE';
